import { render, staticRenderFns } from "./CardManagerRoles.vue?vue&type=template&id=98fd8166&"
import script from "./CardManagerRoles.vue?vue&type=script&lang=js&"
export * from "./CardManagerRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports